import React from 'react';
import firstImage from "../assets/Blackwomen/BWI8.jpg";
import secondImage from "../assets/ImagesofApp/AppImages3.webp";

function Services() {
  return (
    <section className='bg-[#7F7E75]'>
      <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <p className="text-md uppercase text-white mb-4">How I Can Help</p>
          <h2 className="text-3xl md:text-5xl uppercase text-white font-storia">
            Choose Your Path
          </h2>
        </div>

        <ul className="grid gap-10 md:grid-cols-2">
          {/* Work With Me */}
          <li className="bg-white  p-6 md:p-10 flex flex-col items-center text-center">
            <div className="w-full h-64 md:h-72 overflow-hidden">
              <img
                src={firstImage}
                alt="Consultant meeting her client"
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-2xl md:text-3xl font-semibold text-black uppercase font-storia mt-6">
              Work With Me
            </h3>
            <p className="text-black text-lg md:text-xl font-light mt-4 mb-6 max-w-md">
             If you're launching a coaching program, building a course, or outgrowing Wix — you’re in the right place. I’ll help you craft a platform that fits your exact needs — no templates or plugins required.
            </p>
            <a href="/services">
              <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border border-black uppercase">
                Explore Services →
              </button>
            </a>
          </li>

          {/* DIY Templates */}
          <li className="bg-white  p-6 md:p-10 flex flex-col items-center text-center">
            <div className="w-full h-64 md:h-72 overflow-hidden">
              <img
                src={secondImage}
                alt="Team of people working together"
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-2xl md:text-3xl font-semibold text-black uppercase font-storia mt-6">
              Custom Websites & Platforms
            </h3>
            <p className="text-black text-lg md:text-xl font-light mt-4 mb-6 max-w-md">
           Need a faster launch without sacrificing quality? Explore our streamlined custom websites, client dashboards, onboarding flows, and private resource hubs — all built with React and Firebase, and ready to tailor to your coaching, wellness, or community brand. DIY-friendly in spirit, but backed by pro-level strategy and performance.
            </p>
            <a href="/templateshop">
              <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border border-black uppercase">
                Shop Templates →
              </button>
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
}

export default Services;
